import { render, staticRenderFns } from "./customSentNotificationsGrid.vue?vue&type=template&id=5d5e22a2&scoped=true&"
import script from "./customSentNotificationsGrid.vue?vue&type=script&lang=js&"
export * from "./customSentNotificationsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e22a2",
  null
  
)

export default component.exports